<template>
	<div class="row">
		<div class="columns">
			<div class="panel">
				<div class="row">
					<div class="large-5 large-offset-1 columns">
						<!-- <h2 class="text-center">Tell your story</h2> -->

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline required"
									for="settings[club-name]"
									>Club Name</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fa fa-info"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[club-name]"
											id="settings[club-name]"
											type="text"
											placeholder="Your Club Name"
											:disabled="saving"
											v-model="settings.clubName"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline required"
									for="settings[phone]"
									>Phone</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fa fa-phone"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[phone]"
											id="settings[phone]"
											type="tel"
											placeholder="Your phone number"
											v-model="settings.phone"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[website]"
									>Website</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fa fa-desktop"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[website]"
											type="text"
											placeholder="Your website address"
											v-model="settings.website"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[facebook]"
									>Facebook</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fab fa-facebook"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[facebook]"
											type="text"
											placeholder="Your Facebook profile"
											v-model="settings.facebook"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[twitter]"
									>Twitter</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fab fa-twitter"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[twitter]"
											type="text"
											placeholder="Your Twitter profile"
											v-model="settings.twitter"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[instagram]"
									>Instagram</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fab fa-instagram"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[instagram]"
											type="text"
											placeholder="Your Insta handle"
											v-model="settings.instagram_handle"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>



						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[youtube]"
									>YouTube</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fab fa-youtube"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[youtube]"
											type="text"
											placeholder="Your YouTube account"
											v-model="settings.youtube_account"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[tiktok]"
									>TikTok</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fab fa-tiktok"></i
										></span>
									</div>
									<div class="columns small-10">
										<input
											name="settings[tiktok]"
											type="text"
											placeholder="Your TikTok handle"
											v-model="settings.tiktok_handle"
											:disabled="saving"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="large-5 columns end">

						<div class="row">
							<div class="columns medium-3">
								<label
									class="field-label inline"
									for="settings[timezone]"
									>Timezone</label
								>
							</div>

							<div class="columns medium-9 end">
								<div class="row collapse">
									<div class="small-2 columns">
										<span class="prefix"
											><i class="fa fa-clock"></i
										></span>
									</div>
									<div class="columns small-10">
										<SelectTimezone />
									</div>
								</div>
							</div>
						</div>

              <div v-if="settings.countrySupportsListingSite">
                <h6 class="mbs">ClassForKids Discovery</h6>
                <div class="mbs">
                  <ToggleWithLabel feature="listingsActive" setting="listingsActive" label="List my classes" class="controls" />
                </div>


                <p class="smaller mbs">
                  Please provide a short description of what makes your club great! 🎉
                </p>


                <textarea
                  :disabled="saving"
                  name="settings[listing-description]"
                  rows="5"
                  id="settings[listing-description]"
                  v-model="settings.description"
                  placeholder=""
                  class="mbs"
                ></textarea>

                <p class="smaller mtn mbs">
                  <strong>This description will appear on
                    www.class4kids.co.uk when your classes are listed</strong>
                </p>
              </div>
            </div>

						<div class="row text-center">
							<div class="large-5 columns end text-center">
								<button
									class="expand success"
									@click="updateAllSettings"
									:disabled="!hasRequiredDetails || saving"
									v-html="buttonText"
								>
									Save
								</button>
                <label class="text-right required">required</label>
							</div>
						</div>


				</div>
			</div>
		</div>
	</div>
</template>

<script>


import { debounce } from 'lodash';
import ToggleWithLabel from './ToggleWithLabel';
import SelectTimezone from './SelectTimezone';

export default {
  name: 'AboutClient',
  data() {
    return {
      loading: true,
      saving: false,
    };
  },

  methods: {
    async updateSettings(value, payload) {
      this.saving = true;
      await this.$store.dispatch('UPDATE_SETTINGS', payload);
      this.saving = false;
    },

    async updateAllSettings() {
      this.saving = true;
      await this.$store.dispatch('UPDATE_SETTINGS', this.settings);

      if (this.isOnSignUp) {
        window.location.replace(
          '/cms/transition/splash/payment',
        );
      } else {
        this.saving = false;
      }
    },

    updateSettingsOnInput: debounce(function (value, settingName) {
      const payload = {};
      payload[settingName] = value;
      this.updateSettings(value, payload);
    }, 1000),
  },

  computed: {
    settings() {
      return this.$store.getters.settings;
    },

    clubName: {
      get() {
        return this.$store.getters.settings.clubName;
      },

      set(value) {
        this.updateSettingsOnInput(value, 'clubName');
      },
    },

    isOnSignUp() {
      return this.$store.getters.onSignUp;
    },

    buttonText() {
      if (this.saving) {
        return 'Please wait <i class="fal fa-circle-notch fa-spin fa-lg fa-fw"></i>';
      }
      if (this.isOnSignUp) {
        return 'Save and continue';
      }
      return 'Save';
    },

    hasRequiredDetails() {
      return (
        this.settings.clubName.length > 0
				&& this.settings.phone.length > 0
      );
    },
  },

  components: {
    SelectTimezone,
    ToggleWithLabel,
  },

  beforeMount() {
    // this.setting = this.$root.$el.dataset.settingName;
    // this.label = this.$root.$el.dataset.settingLabel;
  },

  mounted() {},
  created() {},
};
</script>

<style scoped>
[v-cloak] {
	display: none;
}

label.required:after {
	content: '*';
	color: red;
}

.controls {
  display: flex !important;
  justify-content: space-between !important;
}

</style>
